import { Link } from "react-router-dom";

export default function Logo({ className = "", variant = "nav", testId = "brand-logo" }) {
  const sizes = {
    nav: "h-11 md:h-12",
    footer: "h-16 md:h-20",
    hero: "h-24 md:h-32",
  };
  return (
    <Link
      to="/foundation"
      data-testid={testId}
      className={`group inline-flex items-center ${className}`}
      aria-label="The Tandem T Foundation — Home"
    >
      <img
        src="/brand/tandem-t-crest.png"
        alt="The Tandem T Foundation"
        className={`${sizes[variant]} w-auto object-contain transition-opacity duration-300 group-hover:opacity-90`}
        style={{ mixBlendMode: "screen" }}
      />
    </Link>
  );
}
